/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoAsanaProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-prod" */ './utils').then(
			(m) => m.ForgeUnitoAsanaProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/icon' },
);

const LazyForgeUnitoAsanaProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoAsanaProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoAsanaProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoAsanaProdIconComponent />
	</Suspense>
);

export const ForgeUnitoAsanaProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoAsanaProdSearchResultIconComponent />
	</Suspense>
);
